module.exports = __webpack_public_path__ + "img/1-fm-chill.10bb7d84.png";